import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import classes from "../DashboardStyles/DashboardStyles.module.css";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const CreditUserDashboard = () => {
  const sideBarToggled = useSelector((data) => data?.sideBarToggle.value);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div
      className={classes.dashboard_wrapper}
      style={{
        marginLeft: isMobile ? "0" : sideBarToggled ? "80px" : "330px",
        transition: "margin-left 0.3s ease",
      }}
    >
      <div className={`${classes.HeaderBar} ${classes.vendorHeader}`}>
        {isMobile && <Sidebar />}
        {!isMobile && <Sidebar />}
      </div>
      <div
        className={
          sideBarToggled ? classes.mainContentClose : classes.mainContent
        }
      >
        <Outlet />
      </div>
    </div>
  );
};

export default CreditUserDashboard;
